var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPodium(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 305 136",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:#e2e2e2;}.cls-3{fill:#329e51;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_5"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 102.5,
    y: 14,
    width: 100,
    height: 122
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "202.5 14 102.5 14 117.5 0 187.5 0 202.5 14"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    y: 61,
    width: 100,
    height: 75
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "100 61 0 61 15 47 100 47 100 61"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 205,
    y: 86,
    width: 100,
    height: 50
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "305 86 205 86 205 72 290 72 305 86"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m47.35,106.92h11.63v4.18h-18.4v-3.82l7.7-4.64c1.49-.91,2.66-1.81,3.53-2.7.86-.89,1.3-1.9,1.3-3.02,0-.98-.34-1.8-1.03-2.45-.68-.65-1.57-.97-2.65-.97-1.32,0-2.35.39-3.08,1.17-.73.78-1.07,1.81-1.03,3.08h-5.11c.05-2.62.89-4.67,2.54-6.16,1.64-1.49,3.89-2.23,6.75-2.23,2.64,0,4.76.68,6.35,2.03,1.6,1.36,2.39,3.15,2.39,5.38,0,1.92-.72,3.59-2.16,5-1.44,1.42-3.48,2.68-6.12,3.78l-2.63,1.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m156.3,83.42h5.98v4.18h-18.04v-4.18h6.84v-12.17l-6.7,2.88v-5.22l8.86-2.56h3.06v17.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m256.08,112.66c2.45.22,4.4,1,5.87,2.34,1.46,1.34,2.2,3.04,2.2,5.08,0,2.33-.85,4.22-2.56,5.69-1.7,1.46-3.89,2.2-6.55,2.2s-5.09-.8-6.91-2.39c-1.82-1.6-2.74-3.63-2.74-6.1h5.18c0,1.27.42,2.32,1.26,3.13.84.82,1.91,1.22,3.2,1.22,1.22,0,2.23-.35,3.01-1.06.78-.71,1.17-1.6,1.17-2.68s-.41-1.96-1.22-2.65c-.82-.68-1.88-1.03-3.2-1.03h-3.1l-1.48-2.95,7.09-6.73h-11.2v-4.36h17.32v4l-7.34,6.3Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPodium);
export default __webpack_public_path__ + "static/media/podium.6c6eed871ec6b17284881bc97e31c0d9.svg";
export { ForwardRef as ReactComponent };